module.exports = __webpack_public_path__ + "static/13-34dfed161e397b73c1f0e99b9dd2e6c6.jpg";